<template>
    <div>
        <div class="SecondTitleRegistration" style="display: flex;justify-content: center;">
            <span>{{ $t('jpnRegistration.counter') }} : {{ this.storeName }}</span>
        </div>
        <van-cell-group style="margin-top: 20px">
            <van-form>
                <van-field
                    required
                    type="textarea"
                    :autosize=true
                    rows="1"
                    :label="this.$t('jpnRegistration.localLastName')"
                    :placeholder="this.$t('common.enter')"
                    v-model="info.localLastName"
                    :error-message="errMessageLastName"
                    @input="validatorLastName()"
                    label-width="125"
                    input-align="right"
                />
                <van-field
                    required
                    type="textarea"
                    :autosize=true
                    rows="1"
                    :label="this.$t('jpnRegistration.localFirstName')"
                    :placeholder="this.$t('common.enter')"
                    v-model="info.localFirstName"
                    :error-message="errMessageFirstName"
                    @input="validatorFirstName()"
                    @focus="validatorLastName()"
                    label-width="125"
                    input-align="right"
                />
                <van-field
                    required
                    type="textarea"
                    :autosize=true
                    rows="1"
                    maxlength="15"
                    :label="this.$t('jpnRegistration.localLastName2')"
                    :placeholder="this.$t('common.enter')"
                    v-model="info.localLastName2"
                    :error-message="errMessageLastName2"
                    @input="validatorLastName2()"
                    @focus="validatorFirstName(),validatorLastName()"
                    label-width="125"
                    input-align="right"
                />
                <van-field
                    required
                    type="textarea"
                    :autosize=true
                    rows="1"
                    maxlength="15"
                    :label="this.$t('jpnRegistration.localFirstName2')"
                    :placeholder="this.$t('common.enter')"
                    v-model="info.localFirstName2"
                    :error-message="errMessageFirstName2"
                    @input="validatorFirstName2()"
                    @focus="validatorFirstName(), validatorLastName(), validatorLastName2()"
                    label-width="125"
                    input-align="right"
                />
                <van-field
                    required
                    :label="this.$t('jpnRegistration.phone')"
                    :placeholder="this.$t('common.enter')"
                    type="number"
                    maxlength="11"
                    v-model="info.phone"
                    :error-message="errMessagePhone"
                    @input="validatorPhone()"
                    @focus="validatorFirstName(),validatorLastName(),validatorFirstName2(),validatorLastName2()"
                    label-width="125"
                    input-align="right"
                />
                <van-field
                    required
                    :disabled=true
                    type="textarea"
                    :autosize=true
                    rows="1"
                    :label="this.$t('jpnRegistration.email')"
                    :placeholder="this.$t('common.enter')"
                    v-model="info.email"
                    :error-message="errMessageEmail"
                    @input="validatorEmail()"
                    @focus="validatorFirstName(),validatorLastName(),validatorFirstName2(),validatorLastName2(),validatorPhone()"
                    label-width="125"
                    input-align="right"
                />
                
                <div class="birth-style">
                    <span style="white-space: nowrap;">{{ this.$t('jpnRegistration.birth')}}</span>
                    <van-field>
                    <template #input>
                        <BirthView class="birth-view"
                            :birth="info.birth" country="JPN" :requiredDay=true :requiredMonth=true :classYMD=true
                            @change="validatorBirthDay(), validatorBirthMonth(), validatorFirstName(), validatorLastName(), validatorFirstName2(), validatorLastName2(), validatorPhone(), validatorEmail()"
                        />
                    </template>
                    </van-field>
                </div>
                <div class="errMsg-birth" v-show="!this.errMessageBirthDay == ''">
                    {{ this.errMessageBirthDay }}
                </div>
                <div class="errMsg-birth" v-show="!this.errMessageBirthMonth == ''">
                    {{ this.errMessageBirthMonth }}
                </div>
                
                <div class="gender-style">
                    <div style="width: 125px;">
                        <span style="white-space: nowrap;">{{ this.$t('jpnRegistration.gender')}}</span>
                    </div>
                    <div style="padding-right: 16px;">
                        <van-dropdown-menu>
                            <van-dropdown-item :title="genderOptions.find(i => i.value == info.gender)?.text || $t('jpnRegistration.select')" v-model="info.gender" :options="genderOptions" />
                        </van-dropdown-menu>
                    </div>
                </div>

                <van-field
                    type="number"
                    maxlength="10"
                    minlength="5"
                    v-model="info.zipCode"
                    :error-message="errMessageZipCode"
                    @input="validatorZipCode()"
                    @focus="validatorFirstName(),validatorLastName(),validatorFirstName2(),validatorLastName2(),validatorPhone(),validatorEmail(),validatorBirthDay(),validatorBirthMonth()"
                    :label="this.$t('jpnRegistration.zipCode')"
                    :placeholder="this.$t('common.enter')"
                    label-width="125"
                    input-align="right"
                />
                <van-field
                    type="textarea"
                    :autosize=true
                    rows="1"
                    v-model="info.prefectures"
                    @focus="validatorFirstName(),validatorLastName(),validatorFirstName2(),validatorLastName2(),validatorPhone(),validatorEmail(),validatorBirthDay(),validatorBirthMonth()"
                    @input="validatorPrefectures()"
                    :label="this.$t('jpnRegistration.prefectures')"
                    :placeholder="this.$t('common.enter')"
                    label-width="125"
                    input-align="right"
                />
                <van-field
                    type="textarea"
                    :autosize=true
                    rows="1"
                    v-model="info.municipalities"
                    @focus="validatorFirstName(),validatorLastName(),validatorFirstName2(),validatorLastName2(),validatorPhone(),validatorEmail(),validatorBirthDay(),validatorBirthMonth()"
                    @input="validatorMunicipalities()"
                    :label="this.$t('jpnRegistration.municipalities')"
                    :placeholder="this.$t('common.enter')"
                    label-width="125"
                    input-align="right"
                />
                <van-field
                    type="textarea"
                    :autosize=true
                    rows="1"
                    v-model="info.address2"
                    @focus="validatorFirstName(),validatorLastName(),validatorFirstName2(),validatorLastName2(),validatorPhone(),validatorEmail(),validatorBirthDay(),validatorBirthMonth()"
                    @input="validatorAddress2()"
                    :label="this.$t('jpnRegistration.address1')"
                    :placeholder="this.$t('common.enter')"
                    label-width="125"
                    input-align="right"
                />
                <van-field
                    type="textarea"
                    :autosize=true
                    rows="1"
                    v-model="info.address3"
                    @focus="validatorFirstName(),validatorLastName(),validatorFirstName2(),validatorLastName2(),validatorPhone(),validatorEmail(),validatorBirthDay(),validatorBirthMonth()"
                    @input="validatorAddress3()"
                    :label="this.$t('jpnRegistration.address2')"
                    :placeholder="this.$t('common.enter')"
                    label-width="140"
                    input-align="right"
                />

                <div class="second-tips">
                    <div>
                        <input 
                            class="agreeCheckBox"
                            type="checkbox"
                            v-model="info.personalInfoAgreeYN"
                            @change="validatorPersonalInfo(),validatorFirstName(),validatorLastName(),validatorFirstName2(),validatorLastName2(),validatorPhone(),validatorEmail(),validatorBirthDay(),validatorBirthMonth()"
                        />
                    </div>
                    <div class="agreeStatement" v-html='$t("jpnRegistration.pInfoAgree").format(privacyPolicyLink)'></div>
                </div>
                <div style="color:#ff0000;margin-left: 45px;">
                    {{ this.errMessagePersonalInfo }}
                </div>
                <div class="second-tips">
                    <div >
                        <input 
                            class="agreeCheckBox"
                            type="checkbox"
                            v-model="info.promotionAgreeYN"
                            @change="validatorPersonalInfo()"
                        />
                    </div>
                    <div class="agreeStatement" v-html='promotionText'></div>
                </div>
                <div style="margin-top: 20px">
                    <van-button
                        :disabled="submitDisabled"
                        size="large"
                        round
                        class="button-submit"
                        @click="submit()"
                        :loading="loading"
                    >{{ $t("common.submit") }}</van-button>
                </div>
            </van-form>
        </van-cell-group>
    </div>
</template>

<script type="text/javascript" src="./../../../lib/kana-1.0.7-min.js"></script>
<script>
import {
    Button,
    Cell,
    CellGroup,
    DropdownItem,
    DropdownMenu,
    Field,
    Switch,
    Checkbox,
    CheckboxGroup,
    Form,
    Radio,
    RadioGroup,
    DatetimePicker,
    Popup,
    Dialog,
} from "vant";
import kana from "./../../../lib/kana-1.0.7-min.js";
import { odsAddOrUpdate, getAddress, getSession, getAuthorizeUrl } from "@/api/eformApi";
import mixins from "./../mixin/Registration.js";
import { zipEncode } from "@/utils/zipcoder";
import { Toast } from "vant";

const FULL_TO_HALF_MAP = {
    // 基本清音
    'ア': 'ｱ', 'イ': 'ｲ', 'ウ': 'ｳ', 'エ': 'ｴ', 'オ': 'ｵ',
    'カ': 'ｶ', 'キ': 'ｷ', 'ク': 'ｸ', 'ケ': 'ｹ', 'コ': 'ｺ',
    'サ': 'ｻ', 'シ': 'ｼ', 'ス': 'ｽ', 'セ': 'ｾ', 'ソ': 'ｿ',
    'タ': 'ﾀ', 'チ': 'ﾁ', 'ツ': 'ﾂ', 'テ': 'ﾃ', 'ト': 'ﾄ',
    'ナ': 'ﾅ', 'ニ': 'ﾆ', 'ヌ': 'ﾇ', 'ネ': 'ﾈ', 'ノ': 'ﾉ',
    'ハ': 'ﾊ', 'ヒ': 'ﾋ', 'フ': 'ﾌ', 'ヘ': 'ﾍ', 'ホ': 'ﾎ',
    'マ': 'ﾏ', 'ミ': 'ﾐ', 'ム': 'ﾑ', 'メ': 'ﾒ', 'モ': 'ﾓ',
    'ヤ': 'ﾔ', 'ユ': 'ﾕ', 'ヨ': 'ﾖ',
    'ラ': 'ﾗ', 'リ': 'ﾘ', 'ル': 'ﾙ', 'レ': 'ﾚ', 'ロ': 'ﾛ',
    'ワ': 'ﾜ', 'ヲ': 'ｦ', 'ン': 'ﾝ',

    // 小写假名
    'ァ': 'ｧ', 'ィ': 'ｨ', 'ゥ': 'ｩ', 'ェ': 'ｪ', 'ォ': 'ｫ',
    'ャ': 'ｬ', 'ュ': 'ｭ', 'ョ': 'ｮ', 'ッ': 'ｯ',
    'ヮ': 'ﾜ', // 小写"ヮ"的特殊处理

    // 长音
    'ー': 'ｰ',

    // 浊音/半浊音
    'ガ': 'ｶﾞ', 'ギ': 'ｷﾞ', 'グ': 'ｸﾞ', 'ゲ': 'ｹﾞ', 'ゴ': 'ｺﾞ',
    'ザ': 'ｻﾞ', 'ジ': 'ｼﾞ', 'ズ': 'ｽﾞ', 'ゼ': 'ｾﾞ', 'ゾ': 'ｿﾞ',
    'ダ': 'ﾀﾞ', 'ヂ': 'ﾁﾞ', 'ヅ': 'ﾂﾞ', 'デ': 'ﾃﾞ', 'ド': 'ﾄﾞ',
    'バ': 'ﾊﾞ', 'ビ': 'ﾋﾞ', 'ブ': 'ﾌﾞ', 'ベ': 'ﾍﾞ', 'ボ': 'ﾎﾞ',
    'パ': 'ﾊﾟ', 'ピ': 'ﾋﾟ', 'プ': 'ﾌﾟ', 'ペ': 'ﾍﾟ', 'ポ': 'ﾎﾟ',

    // 特殊字符
    'ヴ': 'ｳﾞ',
    'ヵ': 'ｶ', 'ヶ': 'ｹ', // 小写"カ/ケ"
    'ヰ': 'ｲ', 'ヱ': 'ｴ', // 古语假名

    // 组合用假名
    'ㇰ': 'ｸ', 'ㇱ': 'ｼ', 'ㇲ': 'ｽ', 'ㇳ': 'ﾄ', 'ㇴ': 'ﾇ',
    'ㇵ': 'ﾊ', 'ㇶ': 'ﾋ', 'ㇷ': 'ﾌ', 'ㇸ': 'ﾍ', 'ㇹ': 'ﾎ',
    'ㇺ': 'ﾑ', 'ㇻ': 'ﾗ', 'ㇼ': 'ﾘ', 'ㇽ': 'ﾙ', 'ㇾ': 'ﾚ', 'ㇿ': 'ﾛ',

    // 半浊音组合
    '𛅦': 'ｧ', '𛅧': 'ｨ', '𛅨': 'ｩ', '𛅩': 'ｪ', '𛅪': 'ｫ'
};

// 特殊处理组合字符
const COMBINED_MAP = {
    'ウ\u3099': 'ｳﾞ', // ウ + 濁点
    'ハ\u3099': 'ﾊﾞ', 'ハ\u309A': 'ﾊﾟ', // ハ + 濁点/半濁点
    'ヒ\u3099': 'ﾋﾞ', 'ヒ\u309A': 'ﾋﾟ',
    'フ\u3099': 'ﾌﾞ', 'フ\u309A': 'ﾌﾟ',
    'ヘ\u3099': 'ﾍﾞ', 'ヘ\u309A': 'ﾍﾟ',
    'ホ\u3099': 'ﾎﾞ', 'ホ\u309A': 'ﾎﾟ',
    'ㇷ゙': 'ﾌﾞ', 'ㇷ゚': 'ﾌﾟ' // 特殊小写组合
};
export default {
    name: "Registration",
    mixins: [mixins],
    components: {
        [Popup.name]: Popup,
        [DatetimePicker.name]: DatetimePicker,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
        [Form.name]: Form,
        [CellGroup.name]: CellGroup,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
        [Switch.name]: Switch,
        [Cell.name]: Cell,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Field.name]: Field,
        [Dialog.Component.name]: Dialog.Component,
        BirthView: () => import("./../components/BirthView"),
    },
    data() {
        return {
            info: {
                localFirstName: "",
                localLastName: "",
                localFirstName2: "",
                localLastName2: "",
                phone: "",
                email: "",
                birth: {
                    day: "",
                    month: "",
                    year: "",
                },
                gender: "",
                address1: "",
                address2: "",
                address3: "",
                zipCode: "",
                prefectures: "",
                municipalities: "",
                personalInfoAgreeYN: false,
                promotionAgreeYN: true,
            },
            loading: false,
            errMessageFirstName: "",
            errMessageLastName: "",
            errMessageFirstName2: "",
            errMessageLastName2: "",
            errMessagePhone: "",
            errMessageEmail: "",
            errMessageBirthDay: "",
            errMessageBirthMonth: "",
            errMessageZipCode: "",
            errMessagePersonalInfo: "",
            genderOptions: [
                { text: this.$t("jpnRegistration.male"), value: "mle" },
                { text: this.$t("jpnRegistration.female"), value: "fml" },
            ],
            specialCharsRegex:  /[`:._~!@#$%^&*() \\+ =<>?"{}|, \\/ ;' \\ [ \] ·~！@#￥%……&*（）—— \\+ ={}|《》？：“”【】、；‘’，。、-]/g,
            emailRegex: /^[0-9a-zA-Z-_.]*@[0-9a-zA-Z-_.]*[.][0-9a-zA-Z]{1,10}$/,
            zipCodeRegex: /^[0-9]{5,10}$/,
            addresses: null,
            sessionKey: 0,
            tpid: this.$route.params.tpid
        };
    },
    computed: {
        privacyPolicyLink() {
            if (this.brandConfig.privacyPolicy) {
                return `<span><a style="color: blue" href="${this.brandConfig.privacyPolicy}">${this.$t("common.privacyPolicy")}</a></span>`;
            } else {
                return `<span>${this.$t("common.privacyPolicy")}</span>`;    
            }
        },
        promotionText() {
            return `<span>${this.$t("jpnRegistration.promotionAgree1")}</span><br/>
            <span style="color: red">${this.$t("jpnRegistration.promotionAgree2")}</span>`;
        },
        currentLocale() {
            return this.$root.$i18n.locale;
        },
        submitDisabled() { 
            return !this.info.personalInfoAgreeYN || this.errMessageFirstName != "" || this.errMessageLastName != "" ||
                this.errMessageFirstName2 != "" || this.errMessageLastName2 != "" || this.errMessagePhone != "" ||
                this.errMessageEmail != "" || this.errMessageBirthDay != "" || this.errMessageBirthMonth != "" ||
                this.errMessageZipCode != "" || this.errMessagePersonalInfo != ""
        }
    },
    created() { 
        this.sessionKey = this.$route.params.sessionKey
        this.info.email = this.$route.params.email
        console.log(this.sessionKey, "--", this.info.email)
        if (!this.info.email) {
            this.$router.push({
                name: 'EnterEmail',
                params: {
                    lang: this.$route.params.lang,
                    brand: this.$route.params.brand,
                    country: this.$route.params.countryPath
                },
                query: {
                    storeId: this.$route.query.storeId,
                }
            })
            return
        }
        this.getAddress()
    },
    watch: {
        currentLocale: {
            handler() {
                if (this.errMessageFirstName != "") {
                    this.validatorFirstName();
                }
                if (this.errMessageLastName != "") {
                    this.validatorLastName();
                }
                if (this.errMessageFirstName2 != "") {
                    this.validatorFirstName2();
                }
                if (this.errMessageLastName2 != "") {
                    this.validatorLastName2();
                }
                if (this.errMessagePhone != "") {
                    this.validatorPhone();
                }
                if (this.errMessageEmail != "") {
                    this.validatorEmail();
                }
                if (this.errMessageBirthDay != "") {
                    this.validatorBirthDay();
                }
                if (this.errMessageBirthMonth != "") {
                    this.validatorBirthMonth();
                }
                if (this.errMessageZipCode != "") {
                    this.validatorZipCode();
                }
                if (this.errMessagePersonalInfo != "") { 
                    this.validatorPersonalInfo();
                }
                this.genderOptions = [
                    { text: this.$t("jpnRegistration.male"), value: "mle" },
                    { text: this.$t("jpnRegistration.female"), value: "fml" },
            ]
            },
        },
    },
    methods: {
        validatorFirstName() {
            this.errMessageFirstName = ""
            this.info.localFirstName = this.info.localFirstName.replace(this.specialCharsRegex, "")
            if (this.info.localFirstName.trim() == "") {
                this.errMessageFirstName = this.$t("jpnRegistration.errMessageFirstName");
                return false;
            }
            return true;
        },
        validatorLastName() {
            this.errMessageLastName = ""
            this.info.localLastName = this.info.localLastName.replace(this.specialCharsRegex, "")
            if (this.info.localLastName.trim() == "") {
                this.errMessageLastName = this.$t("jpnRegistration.errMessageLastName");
                return false;
            }
            return true;
        },
        validatorFirstName2() {
            this.errMessageFirstName2 = ""
            this.info.localFirstName2 = this.info.localFirstName2.replace(this.specialCharsRegex, "")
            this.info.localFirstName2 = this.filterAndConvert(this.info.localFirstName2)
            
            if (this.info.localFirstName2.trim() == "") {
                this.errMessageFirstName2 = this.$t("jpnRegistration.errMessageFirstName2");
                return false;
            }
            return true;
        },
        validatorLastName2() {
            this.errMessageLastName2 = ""
            this.info.localLastName2 = this.info.localLastName2.replace(this.specialCharsRegex, "")
            this.info.localLastName2 = this.filterAndConvert(this.info.localLastName2)
            
            if (this.info.localLastName2.trim() == "") {
                this.errMessageLastName2 = this.$t("jpnRegistration.errMessageLastName2");
                return false;
            }
            return true;
        },
        validatorEmail() {
            this.errMessageEmail = "";
            if (!this.emailRegex.test(this.info.email.trim())) {
                this.errMessageEmail = this.$t("jpnRegistration.errMessageEmail");
                return false;
            }
            return true;
        },
        validatorPhone() {
            this.errMessagePhone = "";
            if (this.info.phone.trim() == "" || this.info.phone.trim().length < 11) {
                this.errMessagePhone = this.$t("jpnRegistration.errMessagePhone");
                return false;
            }
            return true;
        },
        validatorBirthDay() {
            this.errMessageBirthDay = ""
            if (this.info.birth.day == "") {
                this.errMessageBirthDay = this.$t("jpnRegistration.errMessageBirthDay");
                return false;
            } 
            return true;
        },
        validatorBirthMonth() {
            this.errMessageBirthMonth = ""
            if (this.info.birth.month == "") {
                this.errMessageBirthMonth = this.$t("jpnRegistration.errMessageBirthMonth");
                return false;
            } 
            return true;
        },
        validatorZipCode() {
            this.errMessageZipCode = "";
            if (!this.zipCodeRegex.test(this.info.zipCode.trim())) {
                this.errMessageZipCode = this.$t("jpnRegistration.errMessageZipCode");
                this.info.prefectures = ""
                this.info.municipalities = ""
                return false;
            }
            if (this.addresses != null) {
                if (this.addresses[this.info.zipCode.trim()]) {
                    this.info.prefectures = this.addresses[this.info.zipCode.trim()].prefectures
                    this.info.municipalities = this.addresses[this.info.zipCode.trim()].municipalities
                } else {
                    this.info.prefectures = ""
                    this.info.municipalities = ""
                }
            }
            return true;
        },
        validatorPrefectures(){
            // prefectures + municipalities 一共15个字
            this.info.prefectures = this.limitBytes(this.info.municipalities + this.info.prefectures).slice(this.info.municipalities.length)
        },
        validatorMunicipalities(){
            // prefectures + municipalities 一共15个字
            this.info.municipalities = this.limitBytes(this.info.prefectures + this.info.municipalities).slice(this.info.prefectures.length)
        },
        validatorAddress2(){
            this.info.address2 = this.limitBytes(this.info.address2)
        },
        validatorAddress3(){
            this.info.address3 = this.limitBytes(this.info.address3)
        },
        validatorPersonalInfo() {
            this.errMessagePersonalInfo = "";
            if (!this.info.personalInfoAgreeYN) {
                this.errMessagePersonalInfo = this.$t("jpnRegistration.errMessagePersonalInfo");
                return false;
            }
            return true;
        },
        getAddress() {
            getAddress({
                country: this.$route.params.countryPath,
            }).then(res => {
                if (res.success) {
                    this.addresses = res.data
                }
            })
        },
        filterAndConvert(text) {
            // 1. 平假名 → 全角片假名
            let converted = this.hiraganaToKatakana(text);
            
            // 2. 全角片假名 → 半角片假名
            converted = this.fullToHalfKatakana(converted);
            
            // 3. 过滤非法字符（只允许：数字、字母、半角片假名）
            converted = converted.replace(/[^0-9a-zA-Z\uFF66-\uFF9F]/g, "");
            
            return converted;
        },
        hiraganaToKatakana(str) {
            // 平假名范围：\u3041-\u3096
            return str.replace(/[\u3041-\u3096]/g, (match) => String.fromCharCode(match.charCodeAt(0) + 0x60));
        },
        fullToHalfKatakana(str) {
            // 使用上面实现的完整转换函数
            let result = "";
            for (let i = 0; i < str.length; i++) { 
                const current = str[i]; 
                const next = str[i + 1]; 
                const combined = current + (next || ""); 
                if (COMBINED_MAP[combined]) { 
                    result += COMBINED_MAP[combined]; 
                    i++; 
                } else if (FULL_TO_HALF_MAP[current]) {
                    result += FULL_TO_HALF_MAP[current]; 
                } else if (next === "\u3099" || next === "\u309A" ) { 
                    const base = FULL_TO_HALF_MAP[current] || current; 
                    const mark = next === "\u3099" ? "ﾞ" : "ﾟ" ; 
                    result += base + mark; 
                    i++; 
                } else { 
                    result += current; 
                } 
            } 
            return result; 
        },
        submit() {
            this.loading = true;
            if (
                !this.validatorFirstName() | !this.validatorLastName() |
                !this.validatorFirstName2() | !this.validatorLastName2() |
                !this.validatorPhone() | !this.validatorEmail() |
                !this.validatorBirthDay() | !this.validatorBirthMonth() |
                !this.validatorPersonalInfo()
            ) {
                this.loading = false;
                return;
            }

            this.info.localFirstName = this.info.localFirstName.trim()
            this.info.localLastName = this.info.localLastName.trim()
            this.info.localFirstName2 = this.info.localFirstName2.trim()
            this.info.localLastName2 = this.info.localLastName2.trim()
            this.info.email = this.info.email.trim()
            this.info.address1 = this.info.prefectures.trim() + this.info.municipalities.trim()
            this.info.address2 = this.info.address2.trim()
            this.info.address3 = this.info.address3.trim()
            this.info.zipCode = this.info.zipCode.trim()

            this.doAddConsumer(this.sessionKey)
        },
        doAddConsumer(sessionKey) {
            odsAddOrUpdate({
                country: this.$route.params.countryPath,
                storeNo: this.$route.query.storeId,
                brandCode: this.$route.params.brand,
                sessionKey: sessionKey,
                tpid: this.tpid,
                ...this.info,
            }).then((res) => {
                console.log(res)
                if (res.success) {
                    if (res.data.consumerID) {
                        //注册成功
                        if(this.brandConfig.enableLine){
                            //开启Line
                            //判断是否已绑定三方
                            if(res.data.tpid){ //binded, social login
                                //display QRcode page with bindConfirm message
                                this.$router.push({
                                        name: 'QRcodes',
                                        params: {
                                            custId: res.data.consumerID,
                                            storeId: this.$route.query.storeId,
                                            lang: this.$route.params.lang,
                                            brand: this.$route.params.brand,
                                            country: this.$route.params.countryPath,
                                            email: this.info.email,
                                            // 用于QRcode页面展示
                                            localFirstName2: this.info.localFirstName2,
                                            localLastName2: this.info.localLastName2,
                                            tpid: res.data.tpid,
                                            isOptin: this.info.promotionAgreeYN,
                                            bindConfirmMessage: `${res.data.thirdPart} binding is completed.`
                                        },
                                        query: {
                                            storeId: this.$route.query.storeId,
                                        }
                                    })
                            }else{ //unbinded, manually fill in
                                const statement = this.$t("jpnRegistration.confirmLineBinding").format(this.brandConfig.lineOfficialAccountName)
                                Dialog.confirm({
                                    confirmButtonText: this.$t("jpnRegistration.confirmLineBindingNo"),
                                    cancelButtonText: this.$t("jpnRegistration.confirmLineBindingYes"),
                                    cancelButtonColor: 'green',
                                    message: statement
                                })
                                .then(() => {
                                    //on No, display original QRcode page
                                    this.$router.push({
                                        name: 'QRcodes',
                                        params: {
                                            custId: res.data.consumerID,
                                            storeId: this.$route.query.storeId,
                                            lang: this.$route.params.lang,
                                            brand: this.$route.params.brand,
                                            country: this.$route.params.countryPath,
                                            email: this.info.email,
                                            // 用于QRcode页面展示
                                            localFirstName2: this.info.localFirstName2,
                                            localLastName2: this.info.localLastName2,
                                        },
                                        query: {
                                            storeId: this.$route.query.storeId,
                                        }
                                    })
                                })
                                .catch(() => {
                                    //on Yes, redirect to third-part authorize page
                                    getAuthorizeUrl({
                                        thirdPart: 'line',
                                        country: this.$route.params.countryPath,
                                        brand: this.$route.params.brand,
                                        hostPath: window.location.href.split('#')[0],
                                        consentSource: 'popup',
                                        consentStatement: statement,
                                        consumerId: res.data.consumerID,
                                        nextRouter: zipEncode(JSON.stringify({
                                            name: 'QRcodes',
                                            params: {
                                                countryPath: this.$route.params.countryPath,
                                                custId: res.data.consumerID,
                                                storeId: this.$route.query.storeId,
                                                lang: this.$route.params.lang,
                                                brand: this.$route.params.brand,
                                                country: this.$route.params.countryPath,
                                                email: this.info.email,
                                                curLang: this.$root.$i18n.locale,
                                                // 用于QRcode页面展示
                                                localFirstName2: this.info.localFirstName2,
                                                localLastName2: this.info.localLastName2,
                                                isOptin: this.info.promotionAgreeYN,
                                                bindConfirmMessage: `line binding is completed.`
                                            },
                                            query: {
                                                storeId: this.$route.query.storeId,
                                            }
                                        }))
                                    }).then((authRes) => {
                                        if (authRes.success) {
                                            console.log(`${authRes.data.tpid} redirect to line authorize url: ${authRes.data.authorizeUrl}`)
                                            window.location.href = authRes.data.authorizeUrl
                                        } else {
                                            console.log(authRes.errMsg)
                                            Toast.fail({
                                                type: "fail",
                                                message: authRes.errMsg,
                                            });
                                        }
                                    }).catch((err) => {
                                        console.log(err)
                                        Toast.fail({
                                            type: "fail",
                                            message: 'Line Authorize url get failed',
                                        });
                                    })
                                });
                            }
                        }else{
                            //未开启Line, 展示原页面
                            this.$router.push({
                                name: 'QRcodes',
                                params: {
                                    custId: res.data.consumerID,
                                    storeId: this.$route.query.storeId,
                                    lang: this.$route.params.lang,
                                    brand: this.$route.params.brand,
                                    country: this.$route.params.countryPath,
                                    email: this.info.email,
                                    // 用于QRcode页面展示
                                    localFirstName2: this.info.localFirstName2,
                                    localLastName2: this.info.localLastName2,
                                },
                                query: {
                                    storeId: this.$route.query.storeId,
                                }
                            })
                        }
                    } else {
                        Toast.fail(this.$t('common.toastFail'))
                        this.loading = false;
                    }
                } else if (res.data.exist) {
                    Dialog.alert({
                        message: this.$t("jpnRegistration.alreadyRegistered"),
                        confirmButtonText: this.$t("common.confirm")
                    }).then(() => {
                        this.$router.push({
                            name: 'QRcodes',
                            params: {
                                custId: res.data.data.consumerID,
                                storeId: this.$route.query.storeId,
                                lang: this.$route.params.lang,
                                brand: this.$route.params.brand,
                                country: this.$route.params.countryPath,
                                email: this.info.email,
                                // 用于QRcode页面展示
                                // localFirstName2: this.info.localFirstName2,
                                // localLastName2: this.info.localLastName2,
                            },
                            query: {
                                storeId: this.$route.query.storeId,
                            }
                        })
                        this.loading = false
                    })
                } else if (res.data.expired) {
                    getSession({
                        country: this.$route.params.countryPath,
                        email: this.info.email,
                        brandCode: this.$route.params.brand,
                    }).then(res => {
                        this.doAddConsumer(res.data)
                     })
                } else {
                    Toast.fail(this.$t('common.toastFail'))
                    this.loading = false;
                }
            }).catch(() => {
                Toast.fail(this.$t('common.toastFail'))
                this.loading = false;
            })
        },
        filterAndConvert(text) {
            // 1. 平假名 → 全角片假名
            let converted = this.hiraganaToKatakana(text);
            
            // 2. 全角片假名 → 半角片假名
            converted = this.fullToHalfKatakana(converted);
            
            // 3. 过滤非法字符（只允许：数字、字母、半角片假名）
            converted = converted.replace(/[^0-9a-zA-Z\uFF66-\uFF9F]/g, "");
            
            return converted;
        },
        hiraganaToKatakana(str) {
            // 平假名范围：\u3041-\u3096
            return str.replace(/[\u3041-\u3096]/g, (match) =>
            String.fromCharCode(match.charCodeAt(0) + 0x60));
        },
        fullToHalfKatakana(str) {
            // 使用上面实现的完整转换函数
            let result = "";
            for (let i = 0; i < str.length; i++) { 
                const current=str[i]; 
                const next=str[i + 1]; 
                const combined=current + (next || ""); 
                if (COMBINED_MAP[combined]) { 
                    result +=COMBINED_MAP[combined]; 
                    i++; 
                } else if (FULL_TO_HALF_MAP[current]) {
                    result +=FULL_TO_HALF_MAP[current]; 
                } else if (next==="\u3099" || next==="\u309A" ) { 
                    const base=FULL_TO_HALF_MAP[current] || current; const mark=next==="\u3099" ? "ﾞ" : "ﾟ" ; result +=base + mark; i++; 
                } else { 
                    result +=current; 
                } 
            } 
            return result; 
        },
        replaceSpecialChars(str) {
            if (!str || str == "") {
                return ""
            }
            return str.replace(this.specialCharsRegex, "")
        },
        limitBytes(str) {
            const byteArr = new TextEncoder().encode(str)
            let bytes = byteArr.length
            if (bytes > 45) {
                const byteSubString = byteArr.slice(0, 45)
                return new TextDecoder().decode(byteSubString)
            }
            return str
        },
    },
};
</script>

<style scoped>
* {
    font-family: Helvetica-Regular !important;
}

input.agreeCheckBox {
    transform: scale(1.5);
    margin-top: 33%;
}

.agreeStatement {
    margin-left: 10px;
    margin-right: 24px;
}

.desc-tips-agreeStatement {
    font-size: 15px !important;
}

.second-tips {
    display: inline-flex;
    font-size: 14px;
    font-family: Helvetica-Regular;
    font-weight: 400;
    margin-top: 15px;
    margin-left: 15px;
    line-height: 20px;
    width: 100%;
}

.desc-tips {
    display: inline-flex;
    font-family: Helvetica-Regular;
    font-weight: 400;
    line-height: 20px;
    width: 90%;
    padding-left: 30px;
}

.errMsg-birth {
    color:#ff0000;
    text-align: right;
    padding-right: 15px;
}

.second-no-checkbox-tips {
    margin-left: -10px;
    display: inline-flex;
    font-size: 15px;
    font-family: Helvetica-Regular;
    font-weight: 400;
    margin-top: 10px;
    line-height: 20px;
    width: 100%;
}

.second-follow-tips {
    display: inline-flex;
    font-size: 15px;
    font-family: Helvetica-Regular;
    font-weight: 400;
    margin-top: 5px;
    line-height: 20px;
    width: 100%;
}

.third-tips {
    display: inline-flex;
    font-size: 15px;
    font-family: Helvetica-Regular;
    font-weight: 400;
    margin-top: 5px;
    line-height: 30px;
    width: 100%;
    margin-left: 30px;
}

.button-submit {
    background: black;
    color: white;
    border-radius: 7px;
    margin-top: 10px;
}

>>> .van-dropdown-menu {
    width: 100%;
}

>>> .van-dropdown-menu__title {
    font-size: 14px;
}

>>> .van-dropdown-menu__item {
    justify-content: left;
}

>>> .van-dropdown-menu__bar {
    height: unset;
    box-shadow: unset;
}

>>> .van-dialog {
    border-radius: 5px;
}

>>> .birth-view .van-dropdown-menu__item {
    justify-content: right;
}

>>> .van-checkbox {
    /* margin-top: -10% */
}
>>> .van-field__label {
    color:#262626
}
</style>

<style lang="less" scoped>
.age .van-radio--horizontal {
    margin-bottom: 5px !important;
}

/deep/ .item1::before {
    position: absolute;
    left: -4px;
    top: 0px;
    color: #ee0a24;
    font-size: 14px;
    content: "*";
}

/deep/ .item2::before {
    position: absolute;
    left: 33%;
    top: 0px;
    color: #ee0a24;
    font-size: 14px;
    content: "*";
}

.gender-style {
    width:95%;
    margin-left: 16px;
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
}

.birth-style {
    width:95%;
    margin-left: 16px;
    align-items: center;
    display: flex;
}
</style>

<style>
.noticeWidth {
    width: 100%;
}
</style>